// ExclusiveAnyCheckPicker.js
import exp from 'constants';
import React, { useRef } from 'react';


import { CheckPicker } from "rsuite";

export const ExclusiveAnyCheckPicker = ({
    data = [],
    valueKey = 'sp_key',
    labelKey = 'name',
    value = [],          // контрольоване значення (масив ключів)
    onChange,            // викликаємо тільки коли масив реально змінився
    ...props
}) => {
    const lastClickAny = useRef(false);

    const arrEq = (a, b) => {
        if (a === b) return true;
        if (!Array.isArray(a) || !Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        // порівняємо як множини
        const sa = new Set(a);
        if (sa.size !== new Set(b).size) return false;
        for (const x of sa) if (!b.includes(x)) return false;
        return true;
    };

    const normalize = (next) => {
        if (!Array.isArray(next)) return [];
        const hasAny = next.some(v => v == null);         // null — це "Any"
        const others = next.filter(v => v != null);
        if (hasAny && others.length) {
            // одночасно Any та інші — вирішуємо по останньому кліку
            return lastClickAny.current ? [null] : others;
        }
        return hasAny ? [null] : others;
    };

    const emit = (next) => {
        if (!onChange) return;
        if (!arrEq(next, value)) onChange(next);
    };

    const handleSelect = (_val, item) => {
        const isAny = item && item[valueKey] == null;
        lastClickAny.current = isAny;

        // UX-оптимізація: якщо клікнули саме "Any", одразу віддаємо [null]
        if (isAny) emit([null]);
        else if (Array.isArray(value) && value.includes(null)) {
            // якщо Any було вибрано, а тепер клацнули не-Any — прибираємо Any і додаємо пункт
            emit([item[valueKey]]);
        }
    };

    const handleChange = (next) => {
        // rsuite все одно викличе onChange після select/deselect — нормалізуємо тут
        const norm = normalize(next);
        lastClickAny.current = false; // після нормалізації прапорець більше не потрібен
        emit(norm);
    };

    const handleClean = () => emit([]);

    return (
        <CheckPicker
            data={data}
            value={value}
            onSelect={handleSelect}
            onChange={handleChange}
            onClean={handleClean}
            valueKey={valueKey}
            labelKey={labelKey}
            {...props}
        />
    );
};

export default ExclusiveAnyCheckPicker;